import ClientSelectorRoutes from "./router/client-selector";

export default [ClientSelectorRoutes];